import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'phonebook-row-btn',
    imports: [CommonModule],
    template: `
    <div class="tw-w-[25px] tw-flex-center tw-cursor-pointer tw-relative">
      <i
        *ngIf="!loading"
        (click)="onClick($event)"
        class="menu-btn  tw-rounded-[5px] mdi  mdi-20px  tw-my-1 text-gray tw-z-10"
        [ngClass]="{
          'tw-bg-rose-100/70 dark:tw-bg-rose-500/10 mdi-minus text-danger': isOpen,
          'tw-bg-green-100/70 dark:tw-bg-green-500/10 mdi-plus text-success': !isOpen && !isZero,
          'bg-light-dark text-gray tw-opacity-50': isZero,
        }"
      >
      </i>
      <span
        class="tw-absolute tw-h-[45px] tw-w-0.5 tw-border-r tw-border-dashed tw-border-gray-400 tw-opacity-50 dark:tw-opacity-30  "
      ></span>
      <span
        *ngIf="loading"
        class="spinner-border spinner-border-sm"
        role=" status"
        aria-hidden="true"
      ></span>
    </div>
  `
})
export class PhonebookRowBtnComponent {
  @Input() loading: boolean;
  @Input() isOpen: boolean;
  @Input() isZero: boolean;
  @Output() btnClick = new EventEmitter<any>();

  onClick(event) {
    if (this.isZero) return;
    this.btnClick.emit(event);
  }
}
